import React from 'react';
import {
  Link,
} from 'react-router-dom'

import illuCoche from '../../../../assets/images/svg-coche.svg';
import illuProtegeSlip from '../../../../assets/images/illu-protege-slip.png';

class ProductWomanOne extends React.Component {
	componentDidMount() {
		document.body.classList.add('femme');
	}

	componentWillUnmount() {
		document.body.classList.remove('femme');
	}

	render() {
		return(
			<div className="content bg-pink">
				<div className="main-wrapper">
					<div className="main-forms main-forms-echantillon">
						<div className="main-forms-inner">
							<h1 className='title'>Protège-slips :</h1>
							<div className="main-form">
								<div className="form-column">
									<div className="bulle active"><img src={illuCoche} alt="Illustration coche" /></div>
									<div className="bulle active"><img src={illuCoche} alt="Illustration coche" /></div>
									<div className="bulle active"><img src={illuCoche} alt="Illustration coche" /></div>
									<div className="bulle active"><img src={illuCoche} alt="Illustration coche" /></div>
								</div>
								<div className="form-inputs">
									<div className="form-info"><p>Les protections les plus fines et discrètes pour fuites urinaires. Les protège-slips sont spécialement conçus pour capturer les odeurs et garder plus au sec qu’un protège-slip classique.</p></div>
									<Link to="/recevoir-des-echantillons" className="form-btn">
										<div className="form-btn-left">
											<p>Recevoir des échantillons</p>
											<span>Cliquer ici</span>
										</div>
										<div className="form-btn-right">
											<img src={illuProtegeSlip} alt="Illustration protège-slip" />
										</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ProductWomanOne
